import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=151fdd96&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=151fdd96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151fdd96",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('C:/app/components/Components/Loader.vue').default})
